import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import "./Introduction.scss";
import lotus from './assets/lotus-yellow.png'


function Introduction() {
    const history = useHistory();
    const goToRoute = useCallback((path) =>  { console.log(path); history.push(path); }, [history]);

  return (
    <div className="main-container">
        <div className="introduction-main-area">
            <div>
                <div className="title" style={{paddingTop: "125px"}}>Introduktion till Ivris</div>
            </div>
            <div className="introduction-text" style={{paddingTop: "10px"}}>
            Checklistan är ett verktyg som stödjer utveckling av idéer för introduktion av välfärdsteknik. Ivris är uppdelad i olika steg, men det är fullt möjligt att hoppa fram och tillbaka mellan de enskilda stegen, beroende på hur idén utvecklas, vilket också bidrar till deltagarnas egen lärprocess. Det finns egentligen inga specifika regler för att använda Ivris utöver fyra vägledande principer att ta hänsyn till inför enskilda aktiviteter och beslut. Principerna ger varje steg konkret vägledning till hur man kan trigga ytterligare samarbeten.

            </div>

        </div>

        <div className="top-right-nav">
          <img style={{margin: "0px auto"}} height="98px" width="151px" src={lotus}></img>
          <button className="nav-btn" onClick={() => goToRoute('/hurfunkardet')}>HUR FUNKAR DET</button>
          <button className="nav-btn" onClick={() => goToRoute('/checklista')}>STARTA CHECKLISTAN</button>

        </div>

        <div className="circle" style={{top: "55%", left: "2%"}}>
          <div className="circle-title">
            SAMARBETE
          </div>
          <div className="circle-text">
          Alla relevanta intressenter, både inom och utanför organisationen, uppmanas till aktivt samarbete.
          </div>
        </div>
        <div className="circle" style={{top: "65%", left: "24%"}}>
          <div className="circle-title">
            PRAGMATISM
          </div>
          <div className="circle-text">
            I diskussionerna bör man fokusera på konkreta konsekvenser och effekter varje beslut kan medföra (t.ex. finansiella, tekniska, tekniska, administrativa).
          </div>
        </div>
        <div className="circle" style={{top: "35%", left: "40%"}}>
          <div className="circle-title">
            KONVERGENS
          </div>
          <div className="circle-text">
          Eventuella spänningar, meningsskiljaktigheter eller konflikter kan uppstå längs vägen men de utgör en viktig del av samordningsarbetet mellan de involverade aktörerna.          </div>
        </div>
        <div className="circle" style={{top: "60%", left: "55%"}}>
          <div className="circle-title">
            INKLUDERING
          </div>
          <div className="circle-text">
            Skillnader i åsikter, kunskap, kompetenser och upplevelser utgör ett mervärde som kan påverka processen positivt och bidra till ett bättre resultat.
          </div>
        </div>

    </div>
  );
}

export default Introduction;
